function initCustomHeader() {
    const header = document.querySelector(".js-header");
    let lastScrollTop = 0;

    window.addEventListener("scroll", minimizeHeader);

    function minimizeHeader() {
        if (window.pageYOffset > 0) {
            header.classList.add("_mini");
        } else {
            header.classList.remove("_mini");
        }
    }

    minimizeHeader();
}

export default initCustomHeader;


// WEBPACK FOOTER //
// ./Core/Shared/CustomHeader/Js/index.js